import React, { useState } from 'react'
import './Blogs.css'
import BlogBanner from './BlogBanner/BlogBanner'
import Enquiry_Component from './Enquiry_Component/Enquiry_Component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faCalendarDays } from '@fortawesome/free-solid-svg-icons'
import Pagination_Holder from '../Common_Component/Pagination_Holder/Pagination_Holder'
import CoursesBannerComponent from '../LoanCompare/CoursesBannerComponent/CoursesBannerComponent'
import { Link } from 'react-router-dom'
const Blogs = () => {

    const courses = [1, 2, 3]

    const data = [
        {
            title: "Types of Retirement Plans in India: Why It Matters",
            subtext: "Planning for retirement isn’t just about saving money—it’s about securing your future, ensuring financial independence, and maintaining the quality of life you deserve after you stop working. In India, with a growing economy and evolving financial landscape, choosing the right retirement plan has become more important than ever.  ",
            date: "10-09-2025",
            img: "/assets/Image/Blogs/blog1.png",
            link: '/blog-1'
        },
        {
            title: "Profcyma Finance Company | Trusted Finance Company for Loan and Insurance",
            subtext: "The ROI of Veteran Hiring: How Investing in Veterans Pays Off",
            date: "10-09-2025",
            img: "/assets/Image/Blogs/blog2.png",
            link: '/blog-2'
        },


    ];

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 6;

    const totalPages = Math.ceil(data.length / perPage);


    const paginatedData = data.slice((currentPage - 1) * perPage, currentPage * perPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <section className='Blogs'>
            <BlogBanner />

            <div className='container'>
                <div className='enquiry_section'>
                    <Enquiry_Component />
                </div>

                <div className='main_blog_content_section'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='row'>
                                {paginatedData?.map((item) => {
                                    return (
                                        <div className='col-md-4 col-sm-6'>
                                            <Link to={item.link}>
                                                <div className='blog_card'>
                                                    <div className='img_holder'>
                                                        <img src={item?.img} className='blog_img' />
                                                    </div>

                                                    <div className='text_container'>
                                                        <p className='blog_title'>{item?.title}</p>
                                                        <p className='blog_subtext'>{item?.subtext}</p>

                                                        <div className='date_holder'>
                                                            <FontAwesomeIcon icon={faCalendarDays} className='date_icon' />
                                                            <p className='date_text'>
                                                                {item?.date}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>

                            <Pagination_Holder
                                onPageChange={currentPage}
                                totalPages={totalPages}
                                handlePageChange={handlePageChange}
                            />

                        </div>

                        <div className='col-lg-4'>
                            {/* <div className='main_course_section'>
                                <div className='row'>
                                    {courses?.map((item) => {
                                        return (
                                            <div className='col-lg-12 col-md-4 col-sm-4 col-6'>
                                                <CoursesBannerComponent />
                                            </div>

                                        )
                                    })}
                                </div>
                            </div> */}
                        </div>

                    </div>
                </div>

            </div>

        </section>
    )
}

export default Blogs
